import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

/** Backend CSV columns: SapVesselCompanyCode, FixedSapVesselCompanyCode, CostCenter */
const TEMPLATE_FILENAME = 'Fixed_Budget_Vessel_Template.csv';

const downloadFixedBudgetVesselTemplateQuery = async () => {
  try {
    const response = await axios.get(apiurl?.downloadFixedBudgetVesselTemplate, {
      responseType: 'blob'
    });
    if (response?.data?.size > 0) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', TEMPLATE_FILENAME);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      showAlert('No template available to download', 'error');
    }
  } catch (e) {
    showAlert('Something went wrong', 'error');
  }
};

const downloadFixedBudgetVesselTemplate = () => {
  return useMutation(downloadFixedBudgetVesselTemplateQuery);
};

export default downloadFixedBudgetVesselTemplate;
